<template>
  <div
    :class="[
      'formCheckboxSimple',
      {
        'formCheckboxSimple--medium': isMedium,
        'formCheckboxSimple--bigLabel': isBiggerLabel,
        'formCheckboxSimple--reverse': isReverse,
      },
    ]"
  >
    <input
      :id="name"
      :name="name"
      :checked="value"
      type="checkbox"
      class="formCheckboxSimple__input"
      :disabled="disabled"
      :class="['formCheckboxSimple__input', value ? 'formCheckboxSimple__input--checked' : '']"
      @change="$emit('input', $event.target.checked)"
    />
    <label :for="name" class="formCheckboxSimple__label">
      <div class="formCheckboxSimple__check" />
      <div v-if="hasHtml" class="formCheckboxSimple__text">
        <slot />
      </div>
      <div v-else-if="label" class="formCheckboxSimple__text">
        {{ label }}
      </div>
    </label>
  </div>
</template>
<script>
export default {
  name: 'FormCheckboxSimple',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isReverse: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: undefined,
    },
    hasHtml: {
      type: Boolean,
      default: false,
    },
    isMedium: {
      type: Boolean,
      default: false,
    },
    isBiggerLabel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.formCheckboxSimple {
  $root: &;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;

  &__input {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  &__label {
    position: relative;
    display: flex;
    cursor: pointer;
    width: fit-content;
    gap: 1rem;
  }

  &__check {
    margin-top: 1px;
    width: 1.6rem;
    height: 1.6rem;
    display: block;
    background-color: $cWhite;
    border: 1px solid $cCheckbox;
    border-radius: 2px;
    color: $cBlack;
    pointer-events: all;
    position: relative;
    padding: 7px;
    transition: background-color $tr;

    &:before {
      content: '';
      @include icomoon('check');
      font-size: 0.6rem;
      color: $cWhite;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      transition: opacity $tr;
      opacity: 0;
    }

    #{$root}__input--checked + #{$root}__label & {
      background-color: $cSec;
      border: 1px solid $cSec;

      &:before {
        opacity: 1;
      }
    }
  }

  &__text {
    position: relative;
    font-family: $fMain;
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: $cMainLight;

    a {
      color: $cMain;
      transition: color $tr;

      &:hover {
        color: $cSec;
      }
    }

    b {
      font-weight: 700;
    }

    @include parent(#{$root}, #{$root}--medium) {
      line-height: 2rem;
      @include rwd('small-tablet') {
        line-height: 2.5rem;
      }
    }
  }

  &--medium {
    & #{$root}__check {
      width: 2rem;
      height: 2rem;
      @include rwd('small-tablet') {
        width: 2.5rem;
        height: 2.5rem;
      }

      &:before {
        font-size: 0.8rem;
        @include rwd('small-tablet') {
          font-size: 1.1rem;
        }
      }
    }
  }

  &--reverse {
    #{$root}__label {
      flex-direction: row-reverse;
    }
  }

  &--bigLabel {
    #{$root}__text {
      font-size: 1.8rem;
      line-height: 2.2rem;
    }
  }

  a {
    text-decoration: underline;
  }
}
</style>
